export enum GameInstanceStatus {
  NOTSTARTED = "WAITING",
  QUEST_IN_PROGRESS = "QUEST_IN_PROGRESS",
  QUEST_AT_LEADERBOARD = "QUEST_AT_LEADERBOARD",
  FINISHED = "FINISHED",
}
